import { render, staticRenderFns } from "./miniSetting.vue?vue&type=template&id=4e62ba2a&scoped=true"
import script from "./miniSetting.vue?vue&type=script&lang=ts"
export * from "./miniSetting.vue?vue&type=script&lang=ts"
import style0 from "./miniSetting.vue?vue&type=style&index=0&id=4e62ba2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e62ba2a",
  null
  
)

export default component.exports